import { tw } from '@/utils/tw';
import BaseLink from 'base/components/Link/theme';

const Link = tw.theme({
  extend: BaseLink,
  base: ['text-center', 'text-headline-sm'],
});

export default Object.assign({}, { Link });
